import apiHandler from "middlewares/apiHandler";
import { PortfolioFilter } from "pages/PortfolioView/Data/PortfolioFilter";
import { PortfolioFilterSelection } from "pages/PortfolioView/Data/PortfolioFilterSelection";
import { PortfolioGlidepathFilter } from "pages/PortfolioView/Data/PortfolioGlidepathModels";
import { ProjectRegisterFilter } from "pages/PortfolioView/Data/ProjectRegisterFilter";
import { ProjectRegisterResult } from "pages/PortfolioView/Data/ProjectRegisterResult";

export const _getTotalEmissionByScopes = async (model: PortfolioFilter) => {
    return apiHandler.post<any>("dashboard/TotalEmissionByScopes", model);
};

export const _getBaselineYearByOrgId = async (orgId: number) => {
  return apiHandler.get<number>(`dashboard/baselineyear/${orgId}`);
};

export const _getMultipleLocationProjectRegisterDetails = async (model: ProjectRegisterFilter) => {
  return apiHandler.post<ProjectRegisterResult>("dashboard/MultipleLocationProjectRegisterDetails", model);
};

export const _addPortfolioFilterSelection = async (model: PortfolioFilterSelection) => {
  return apiHandler.post<PortfolioFilterSelection>("portfolio/filterselection", model);
};

export const _getPortfolioFilterSelection = async (pageName: string) => {
  return apiHandler.get<PortfolioFilterSelection>(`portfolio/filterselection/${pageName}`);
};

export const _getPortfolioGlidepath = async (filter: PortfolioGlidepathFilter) => {
  return apiHandler.post<any>("glidepath/portfolio", filter);
};